import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Polyline, Popup } from "react-leaflet";
import L from "leaflet";

// Fix default marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
    iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const emberIcon = L.divIcon({
    className: "custom-ember-pin",
    html: `<div style="width:28px;height:28px;background:#F26A2E;border:3px solid #fff;border-radius:50%;box-shadow:0 2px 8px rgba(14,36,30,0.3);"></div>`,
    iconSize: [28, 28],
    iconAnchor: [14, 14],
});

export default function MapView({
    center,
    zoom = 12,
    markers = [],
    route = [],
    height = "100%",
    interactive = true,
}) {
    const hasCenter = center && typeof center[0] === "number" && typeof center[1] === "number";
    const fallbackCenter = [39.7392, -104.9903]; // Denver
    const mapCenter = hasCenter ? center : fallbackCenter;

    return (
        <div style={{ width: "100%", height }} data-testid="map-view">
            <MapContainer
                center={mapCenter}
                zoom={zoom}
                scrollWheelZoom={interactive}
                dragging={interactive}
                zoomControl={interactive}
                doubleClickZoom={interactive}
                style={{ width: "100%", height: "100%", borderRadius: "0.75rem" }}
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://osm.org">OpenStreetMap</a>'
                />
                {markers.map((m, i) => (
                    <Marker key={i} position={m.position} icon={emberIcon}>
                        {m.label && <Popup>{m.label}</Popup>}
                    </Marker>
                ))}
                {route && route.length > 1 && (
                    <Polyline positions={route} pathOptions={{ color: "#F26A2E", weight: 4, opacity: 0.85 }} />
                )}
            </MapContainer>
        </div>
    );
}
